"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));
var _react = _interopRequireWildcard(require("react"));
var _xstate = require("xstate");
var _propTypes = require("prop-types");
var _DesktopHeader = _interopRequireDefault(require("./DesktopHeader"));
var _MobileHeader = _interopRequireDefault(require("./MobileHeader"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const stepPropsFromState = (currentState, stepsConfiguration) => {
  const currentStateKey = typeof currentState.value === 'string' ? currentState.value : (0, _keys.default)(currentState.value)[0];
  const activeStep = stepsConfiguration ? (0, _findIndex.default)(stepsConfiguration).call(stepsConfiguration, _ref => {
    let {
      stateKey,
      stepperLabelId
    } = _ref;
    return stepperLabelId !== null && stateKey === currentStateKey;
  }) : -1;
  return {
    activeStepIndex: activeStep !== -1 ? activeStep : 0
  };
};
const propTypes = {
  onGoBack: _propTypes.func.isRequired,
  currentState: (0, _propTypes.instanceOf)(_xstate.State).isRequired,
  aboveMd: _propTypes.bool.isRequired,
  /** header will not render without this configuration object. See lib/constants/steps */
  stepsConfiguration: (0, _propTypes.arrayOf)(_propTypes.object)
};
const Header = /*#__PURE__*/(0, _react.forwardRef)((_ref2, ref) => {
  let {
    onGoBack,
    currentState,
    aboveMd,
    stepsConfiguration
  } = _ref2;
  const {
    activeStepIndex
  } = stepPropsFromState(currentState, stepsConfiguration);
  const {
    hideHeader
  } = currentState.context;
  if (hideHeader) {
    return null;
  }
  return aboveMd ? /*#__PURE__*/_react.default.createElement(_DesktopHeader.default, {
    ref: ref,
    activeStep: activeStepIndex,
    onGoBack: onGoBack,
    stepsConfiguration: stepsConfiguration
  }) : /*#__PURE__*/_react.default.createElement(_MobileHeader.default, {
    ref: ref,
    activeStep: activeStepIndex,
    onGoBack: onGoBack,
    stepsConfiguration: stepsConfiguration
  });
});
Header.displayName = 'Header';
Header.propTypes = propTypes;
var _default = exports.default = Header;
Header.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Header",
  "props": {
    "onGoBack": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "currentState": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "State"
      },
      "required": true
    },
    "aboveMd": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "stepsConfiguration": {
      "description": "header will not render without this configuration object. See lib/constants/steps",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "object"
        }
      },
      "required": false
    }
  }
};